module.exports = "./img/9b200a487469157a70840a9e998f89b4.png";